import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";

import GetCards from "../../components/GetCards/GetCards";
import { Container } from "../../components/Container/Container";
import Filter from "../../components/Filter/Filter";

import { ContainerCatalogSt } from "./style";
import { switchViewInCatalogAction } from '../../store/switchView/actions'

const Catalog = () => {
    // скрываем основной контент страницы и показываем результаты фильтрации
    const [hiddenContentPage, setHiddenContentPage] = useState(false);
    const [render, setRender] = useState(false);
    const [grid, setGrid] = useState(false);

    const dispatch = useDispatch();

    const genres = useSelector((store) => store.allProjects.genres);
    const switchView = useSelector((store) => store.switchViewInCatalog.switchViewInCatalog);

    // componentDidMount
    useEffect(() => {
        dispatch(switchViewInCatalogAction(false));
    }, [dispatch]);

    // componentDidUpdate: реагируем только на изменение switchView, но не на первый рендер
    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        setGrid(true);
    }, [switchView]);

    // скрываем основной контент страницы и показываем результаты фильтрации
    const _hiddenContentPage = useCallback((x) => {
        setHiddenContentPage(x);
    }, []);

    // обновляем состояние фильтра при переходе через "смотреть все"
    const _render = useCallback(() => {
        setRender(true);
        setTimeout(() => {
            setRender(false);
        }, 50);
    }, []);

    return (
        <ContainerCatalogSt>

            <Filter _hiddenContentPage={_hiddenContentPage} render={render} />

            <div style={!hiddenContentPage ? { height: "auto", overflow: "" } : { height: "0", overflow: "hidden" }}>
                <Container>
                    <div style={!switchView ? { height: "auto", overflow: "" } : { height: "0", overflow: "hidden" }}>
                        {genres && genres.map((genres, i) => (
                            <GetCards key={i}
                                sourceCards={`projects?filter%5Bgenre_id%5D=${genres.id}`}
                                title={genres.title}
                                link="/catalog"
                                render={_render}
                                type="catalog"
                                cardDisplayType="carousel"
                            />
                        ))}
                    </div>
                </Container>

                {grid && <Container padding="true">
                    <div style={switchView ? { height: "auto", overflow: "" } : { height: "0", overflow: "hidden" }}>
                        <GetCards
                            sourceCards={`projects?sort[column][]=year_start&sort[column][]=title.ru&sort[order][]=desc&sort[order][]=asc`}
                            type="catalog"
                            cardDisplayType="grid"
                            tile={true}
                        />
                    </div>
                </Container>}
            </div>


        </ContainerCatalogSt>
    )
}

export default Catalog;
